import { render, staticRenderFns } from "./ThankYouView.vue?vue&type=template&id=047d585a&scoped=true"
var script = {}
import style0 from "./ThankYouView.vue?vue&type=style&index=0&id=047d585a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d585a",
  null
  
)

export default component.exports